var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { spacer40 } from '@spotify-internal/encore-web/core';
import React from 'react';
import styled from 'styled-components';
import { Grid, TWO_COLUMN_MAX_WIDTH } from '../Grid';
var StyledGrid = styled(Grid)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  padding-bottom: 52px;\n  & > * {\n    grid-column-start: span 3;\n    @media (max-width: ", ") {\n      grid-column-start: span 1;\n    }\n  }\n  grid-row-gap: ", ";\n"], ["\n  padding-bottom: 52px;\n  & > * {\n    grid-column-start: span 3;\n    @media (max-width: ", ") {\n      grid-column-start: span 1;\n    }\n  }\n  grid-row-gap: ", ";\n"])), TWO_COLUMN_MAX_WIDTH, spacer40);
export var CategoryMenu = function (_a) {
    var column1 = _a.column1, column2 = _a.column2, column3 = _a.column3, column4 = _a.column4;
    return (React.createElement(StyledGrid, null,
        column1,
        column2,
        column3,
        column4));
};
var templateObject_1;
